module.exports = __webpack_public_path__ + "img/tick_green.c083298f.svg";